$(document).ready(function(){
    //
    if ( $('.home_jackets_section').length ) {

 		const content1 = $(".feature-row__item_item.feature-row__item_item_1");
	    const content2 = $(".feature-row__item_item.feature-row__item_item_2");
	    const content3 = $(".feature-row__item_item.feature-row__item_item_3");
	    const content4 = $(".feature-row__item_item.feature-row__item_item_4");
        const content5 = $(".feature-row__item_item.feature-row__item_item_5");
	    const counter = $(".home_jackets_section .counter .first");
	    gsap.set([content2, content3, content4, content5],{autoAlpha:0});

	    var current = content1;


	    $(".home_jackets_section nav .arrow-down").click(function() {
     
	        var prev = current.prev('.feature-row__item_item');
	        var lengthNumber = parseInt(prev.length);
	        var counterLabel = prev.attr('data-number');
	        counterLabel = "0"+counterLabel;

	        if ( current != content1 && lengthNumber == 1 ){

	            if ( counterLabel == "02" ){

	                /*let tl = gsap.timeline();
	                    tl.to(imageCoatBox, {scale:3, ease: "expoScale(0.1, 3)"}, 0)
	                      .to(imageCoat, {xPercent: -10, yPercent: -25}, 0);*/

	            }else if ( counterLabel == "03" ){

	                //gsap.to(imageCoat, {xPercent: 25, yPercent: -40});

	            }else if ( counterLabel == "01" ){

	                /*let tl = gsap.timeline();
	                    tl.to(imageCoatBox, {scale:1, ease: "expoScale(0.1, 1)"}, 0)
	                      .to(imageCoat, {xPercent: 0, yPercent: 0}, 0);*/
	                
	            }

	            gsap.to(current, {autoAlpha:0});
	            gsap.to(prev, {autoAlpha:1});
	            counter.html(counterLabel);
	            current = prev;

	        }else{

	            current = content1;

	        }

	        

	    });


	    $(".home_jackets_section nav .arrow-up").click(function() {

			console.log("arrow up");
	            
	        var next = current.next();
	        var lengthNumber = parseInt(next.length);
	        var counterLabel = next.attr('data-number');
	        counterLabel = "0"+counterLabel;

	        if ( current != content5 && lengthNumber == 1 ){

	            gsap.to(current, {autoAlpha:0});
	            gsap.to(next, {autoAlpha:1});
	            counter.html(counterLabel);

	            // if ( counterLabel == "02" ){

	            //     let tl = gsap.timeline();
	            //         tl.to(imageCoatBox, {scale:3, ease: "expoScale(0.1, 3)"}, 0)
	            //           .to(imageCoat, {xPercent: -10, yPercent: -25}, 0);

	            // }else if ( counterLabel == "03" ){

	            //     gsap.to(imageCoat, {xPercent: 25, yPercent: -40});

	            // }else if ( counterLabel == "04" ){

	            //     gsap.to(imageCoat, {xPercent: 0, yPercent: 40});

	            // }

	            current = next;

	        }else{

	            current = content5;

	        }

	        

	    });

 	}

    /* Slide details product */

    if ( $(".fosfo_custom_section").length ){

        var fosfoDetailsSlider = $(".fosfo_custom_section .slider");

        fosfoDetailsSlider.slick({
			
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 400,
            autoplay: false,
            loop: true,
            accessibility: true,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode:true
                    }
                },
            ]
        });


        if ($(".fosfo_custom_section .rl").length && $(".fosfo_custom_section .slick-prev").length) {
            $(".fosfo_custom_section .rl").click(function () {
                $(".fosfo_custom_section .slick-prev").click();
            });
        }
        if ($(".fosfo_custom_section .rr").length && $(".fosfo_custom_section .slick-next").length) {
            $(".fosfo_custom_section .rr").click(function () {
                $(".fosfo_custom_section .slick-next").click();
            });
        }


        var $progressBarDetails = $('.fosfo_custom_section .progress');
        var iCompteur = parseInt($('.fosfo_custom_section .inner_slider').length);
        var percentProgress = 100 / iCompteur;
        $progressBarDetails.css('background-size', percentProgress+'% 100%').attr('aria-valuenow', percentProgress);

        fosfoDetailsSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            var calc = (((nextSlide) / (slick.slideCount - 1)) * 100) + percentProgress;
            $progressBarDetails
                    .css('background-size', calc + '% 100%')
                    .attr('aria-valuenow', calc);
        });


    }

});